export const enum ASYNC_DATA_KEYS {
  // Payment & Gateway
  MEMBER_CARDS = 'member-cards',
  ORDER_PAYMENT_RETURN = 'order-payment-return',
  PAYMENT_GATEWAY = 'payment-gateway',

  // Branch
  BRANCH_INFO = 'branch-info',

  // Product & Category
  PRODUCTS = 'products',
  PRODUCT_INFO = 'product-info',
  PRODUCT_COMMENTS = 'product-comments',
  BRANCH_PRODUCTS = 'branch-products',
  CATEGORY_INFO = 'category-info',
  THEME_INFO = 'theme-info',
  REGION_CATEGORIES = 'region-categories',
  REGION_THEMES = 'region-themes',
  FILTER_OPTIONS = 'filter-options',

  // Booking
  BOOKING_REMARKS = 'booking-remarks',

  // Member
  MEMBER_COUPONS = 'member-coupons',
  MEMBER_ORDERS = 'member-orders',
  MEMBER_FUN_COINS = 'member-fun-coins',
  MEMBER_PAYMENT_INFO = 'member-payment-info',
  MEMBERSHIP_LEVEL_COMPARISON = 'membership-level-comparison',
  MEMBER_EXCLUSIVES = 'member-exclusives',

  // Order
  ORDER_DETAIL = 'order-detail',
  ORDER_TAG_DATA = 'order-tag-data',
  ORDER_RESCHEDULE_INFO = 'order-reschedule-info',

  // Search
  SEARCH_HINT_KEYWORDS = 'search-hint-keywords',

  // Favorites
  FAVORITE_LIST = 'favorite-list',

  // Reservation
  CROSS_DAYS_DATA = 'cross-days-data',

  // Product
  FILTER_PRODUCT_COUNT = 'filter-product-count',
  PRODUCT_STATIC_DATA = 'product-static-data',

  // Fun Coins
  FUN_COINS_INFO = 'fun-coins-info',
}

export const getAsyncDataKey = (baseKey: string, params: (string | number)[] = []) => `${baseKey}_${params.join('_')}`
